import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import { getNotificationApi, getReadNotificationApi } from "../../API/API";

function* getNotificationsSaga(action) {
    try {
        // const { id } = action.payload;
        const response = yield call(() => getNotificationApi(action));
        // console.log('response in get notification', response.data)
        yield put({ type: types.GET_NOTIFICATION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_NOTIFICATION_FAILURE, error });
    }
}

function* getReadNotificationsSaga(action) {
    try {        
        const { id } = action.payload;
        const response = yield call(() => getReadNotificationApi(id));
        yield put({ type: types.READ_NOTIFICATION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.READ_NOTIFICATION_FAILURE, error });
    }
}
export function* watchGetNotifications() {
    yield takeLatest(types.GET_NOTIFICATION_REQUESTED, getNotificationsSaga);
}
export function* watchGetReadNotifications() {
    yield takeLatest(types.READ_NOTIFICATION, getReadNotificationsSaga);
}
